// The video editor's timeline strings (components/Editor), under t('editor.rve.timeline.<key>').
// Same keys in en, es, pt and ar; Arabic follows ../../ARABIC_STYLE.md.
export default {
  // Header: undo / redo
  undoTitle: 'Undo (Ctrl/Cmd + Z)',
  undoLabel: 'Undo last action',
  redoTitle: 'Redo (Ctrl/Cmd + Shift + Z)',
  redoLabel: 'Redo last action',
  // Header: splitting
  selectItemToSplit: 'Select an item to split at playhead',
  selectOneItemToSplit: 'Select only one item to split',
  movePlayheadToSplit: 'Move playhead over selected item to split',
  splitSelectedItem: 'Split selected item at playhead',
  clickItemsToSplit: 'Click timeline items to split them',
  enableSplittingMode: 'Enable splitting mode',
  autoRemoveEmptyTracks: 'Auto-remove empty tracks',
  enableAutoRemoveEmptyTracks: 'Enable auto-removal of empty tracks',
  // Header: playback
  jumpToStart: 'Jump to Start',
  jumpToEnd: 'Jump to End',
  playVideo: 'Play Video',
  pauseVideo: 'Pause Video',
  // Header: aspect ratio
  aspectRatio: 'Aspect Ratio',
  widescreen: 'Widescreen',
  vertical: 'Vertical',
  square: 'Square',
  portrait: 'Portrait',
  // Header: zoom and collapse
  zoomOut: 'Zoom Out',
  zoomIn: 'Zoom In',
  resetZoom: 'Reset Zoom',
  timelineZoom: 'Timeline Zoom',
  expandTimeline: 'Expand Timeline',
  collapseTimeline: 'Collapse Timeline',
  // Track handles
  reorderTrack: 'Reorder track',
  enableMagnetic: 'Enable magnetic timeline',
  disableMagnetic: 'Disable magnetic timeline',
  deleteTrack: 'Delete track',
  gapTitle: 'Gap: {start}s - {end}s (Click to close)',
  // Item context menu
  duplicate: 'Duplicate',
  duplicateItems: 'Duplicate {n} items',
  splitAtPlayhead: 'Split at playhead',
  delete: 'Delete',
  deleteItems: 'Delete {n} items',
  // Item labels
  videoLabel: 'VIDEO',
  imageLabel: 'IMAGE',
  textLabel: 'TEXT',
  audioLabel: 'AUDIO',
  captionLabel: 'CAPTION',
  subtitlesLabel: 'Subtitles',
  stickerLabel: 'STICKER',
  blurLabel: 'BLUR',
  blurLevelLabel: 'BLUR ({n}px)',
  unknownLabel: 'Unknown',
  typeLabel: 'Type: {type}',
  loading: 'Loading...',
  noWaveform: 'No waveform',
  // Shared editor UI (ui/dialog, ui/sidebar)
  close: 'Close',
  toggleSidebar: 'Toggle Sidebar',
};
